import "angular";
import ShowMoreOrLessDirective from "./ShowMoreOrLessDirective";
import ShowMoreOrLessValidationFactory from "./ShowMoreOrLessValidationFactory";
import WordBasedTruncationFactory from "./WordBasedTruncationFactory";
import ExtendCharBasedTruncationFactory from "./ExtendCharBasedTruncationFactory";

var moduleName = "ShowMoreOrLessModule";
var moduleDependencies = [
];

const ShowMoreOrLessModule = angular.module(moduleName, moduleDependencies)
    .directive("showMoreOrLess", ShowMoreOrLessDirective)
    .factory("showMoreOrLessValidationFactory", ShowMoreOrLessValidationFactory)
    .factory("wordBasedTruncationFactory", WordBasedTruncationFactory)
    .factory("extendCharBasedTruncationFactory", ExtendCharBasedTruncationFactory);

export default ShowMoreOrLessModule;
